// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\shared\\PeopleSection\\index.tsx"
);
import.meta.hot.lastModified = "1757171103357.4683";
}
// REMIX HMR END

export { PeopleSection } from "./PeopleSection";
export type { Person, FilterOptions } from "./PeopleSection";